import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import config from "../config";
import "./css/loginwithtelegram.css";
import ErrorPopup from './errorpopup';

const LoginWithTelegram = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [telegramId, setTelegramId] = useState("");
  const [code, setCode] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  const handleTelegramLogin = () => {
    window.location.href = "https://t.me/Ficus_auth_bot?start=start";
  };

  const handleAuthResponse = useCallback(async (token) => {
    try {
      const response = await axios.get(`${config.API_URL}/user_info`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUserInfo(response.data);
      setError(null);
      navigate('/');
    } catch (err) {
      setError('Не удалось авторизоваться через Telegram');
    }
  }, [navigate]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const errorQuery = queryParams.get('error');

    if (errorQuery) setError(errorQuery);

    if (token) {
      localStorage.setItem('token', token);
      handleAuthResponse(token);
    }
  }, [location, handleAuthResponse]);

  const handleCodeLogin = async () => {
    if (!telegramId.trim() || !code.trim()) {
      setError("Введите ID и код!");
      return;
    }

    try {
      const response = await axios.post(`${config.API_URL}/login_with_code`, {
        telegram_user_id: telegramId,
        code
      });

      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
        navigate("/");
      }
    } catch (err) {
      setError("Ошибка входа по коду");
    }
  };

  return (
    <div className="login-page">
      <div className="title-container">
        <h1 className="header-title">Ficus education</h1>
        <div className="line"></div>
      </div>

      <div className="login-buttons">
        <button onClick={handleTelegramLogin} className="sliding-button">
          Регистрация
        </button>
        <button onClick={() => setShowPopup(true)} className="sliding-button">
          Войти по коду
        </button>
      </div>

      {userInfo && (
        <div>
          <h3>Добро пожаловать, {userInfo.username}!</h3>
          <p>Группа: {userInfo.group}</p>
        </div>
      )}

      {showPopup && (
        <div className="form">
          <h3 id='heading'>Вход по коду</h3>
          <input
            className='input-field'
            type="text"
            placeholder="Введите ваш Telegram ID"
            value={telegramId}
            onChange={(e) => setTelegramId(e.target.value)}
          />
          <input
            className='input-field'
            type="text"
            placeholder="Введите код"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button className='button1' onClick={handleCodeLogin}>Войти</button>
          <button className='button1' onClick={() => setShowPopup(false)}>Отмена</button>
        </div>
      )}

      <ErrorPopup message={error} onClose={() => setError(null)} />
    </div>
  );
};

export default LoginWithTelegram;
